import useTranslation from 'hooks/useTranslation'
import Popup from 'components/popups/Popup'
import useLogout from 'hooks/useLogout'
import { UserAndCompanyData } from '.'
import React from 'react'
import './style.scss'

interface SelectUserToCartPopupProps {
  data: UserAndCompanyData
  userData?: UserAndCompanyData['user'] | null
  callback: (saveTenantData?: boolean) => void
}

const SelectUserToCartPopup: React.FC<SelectUserToCartPopupProps> = ({ data, userData, callback }) => {
  const { t } = useTranslation('restore')
  const logout = useLogout()
  return (
    <Popup>
      <div className='selectUserToCart__popup'>
        <div className='popup__title'>
          <div>{t('attention')}</div>
          <div>{t('youMustSelectAccountToContinueRental')}</div>
        </div>
        <div className='selectUserToCart__options'>
          <div
            className='selectUserToCart__option'
            onClick={() => {
              callback()
            }}>
            <div className='group'>
              <div className='selectUserToCart__option__title'>{t('accountYouAreLoggedInTo')}</div>
              <div className='selectUserToCart__option__arrow center'>
                <i className='icon icon--arrow-right' />
              </div>
            </div>
            <div className='selectUserToCart__option__desc'>
              <div>{t('name')}: {userData?.name}</div>
              <div>{t('email')}: {userData?.email}</div>
            </div>
          </div>
          <div
            className='selectUserToCart__option'
            onClick={() => {
              logout()
              callback(true)
            }}>
            <div className='group'>
              <div className='selectUserToCart__option__title'>{t('accountUsedToCreateCart')}</div>
              <div className='selectUserToCart__option__arrow center'>
                <i className='icon icon--arrow-right' />
              </div>
            </div>
            <div className='selectUserToCart__option__desc'>
              <div>{t('name')}: {data?.user?.name}</div>
              <div>{t('email')}: {data?.user?.email}</div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  )
}

export default SelectUserToCartPopup